<template>
  <div class="slider">
    <div class="slider-main">
      <van-slider
        v-model="sliderVal"
        active-color="#dfc2ff"
        inactive-color="#dfc2ff"
        bar-height="8px"
        :max="max"
        :min="min"
      >
        <template #button>
          <div class="custom-button">
            <div class="messageSilde">
              <my-TokenLogo
                styleCss="color: #ffffff;"
                :price="sliderVal"
              ></my-TokenLogo>
            </div>
            <div class="button"></div>
          </div>
        </template>
      </van-slider>
    </div>
    <div class="silder-price">
      <div class="silder-left">
        <my-TokenLogo styleCss="color: #585858;" :price="min"></my-TokenLogo>
      </div>
      <div class="silder-right">
        <my-TokenLogo styleCss="color: #585858;" :price="max"></my-TokenLogo>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 10,
    },
    max: {
      type: Number,
      default: 2000,
    },
    min: {
      type: Number,
      default: 100,
    },
  },
  watch: {
    sliderVal(val) {
      this.$emit("input", val);
    },
  },
  data() {
    return {
      sliderVal: this.value,
    };
  },
};
</script>
<style lang="scss" scoped>
.slider {
    padding-top: 0.8rem;
    width: 100%;
  .slider-main {
    .custom-button {
      position: relative;
      .messageSilde {
        width: 1.6rem;
        height: 0.52rem;
        background-image: url("@/assets/mybox/home/messageSilde.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: absolute;
        top: -123%;
        left: -130%;
        padding: 0.07rem 0.2rem;
        display: flex;
        justify-content: center;
      }
      .button {
        width: 0.44rem;
        height: 0.44rem;
        border-radius: 50%;
        background: #ae6bf7;
      }
    }
  }
  .silder-price {
    display: flex;
    justify-content: space-between;
    margin:0.2rem 0;
    .silder-left {
    }
    .silder-right {
    }
  }
}
</style>
